module.exports = __webpack_public_path__ + "img/AI.dad8ae67.png";